import { render, staticRenderFns } from "./ExistingCustomerDialog.vue?vue&type=template&id=876effea&scoped=true&"
import script from "./ExistingCustomerDialog.vue?vue&type=script&lang=js&"
export * from "./ExistingCustomerDialog.vue?vue&type=script&lang=js&"
import style0 from "./ExistingCustomerDialog.vue?vue&type=style&index=0&id=876effea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876effea",
  null
  
)

export default component.exports